export default __webpack_public_path__ + "static/media/slide4.8af1d761.jpg";